import React, { useEffect } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { Trans, t, date } from '@lingui/macro';
import { I18n } from '@lingui/react';

// Redux
import { loadComments } from 'store/modules/comments/actions';
import { getThreeComments } from 'store/modules/comments/selectors';

// Components
import Image from 'components/Image';
import DateLabel from 'components/DateTime/Label';


const avatarStyles = { width: 40, height: 40 };

const mapState = state => ({
  comments: getThreeComments(state),
});

export default function CommentList({ model, id }) {
  const { comments } = useMappedState(mapState);
  const dispatch = useDispatch();
  useEffect(() => {
    if (model && id) {
      dispatch(loadComments(model, id));
    }
  }, [model, id]);

  return (
    <I18n>
      {({ i18n }) =>
        <div className="mt-10">
          {comments.length > 0 && <h2 className="text-secondary text-xl mb-8"><Trans>Comments</Trans></h2>}
          {comments.map((comment) =>
            <div key={comment.id} className="mb-8 mt-2 flex">
              <Image src={comment.author.image} className="rounded-full" style={avatarStyles} />
              <div className="flex-1 ml-4">
                <h4 className="text-default">{comment.author.name} <small className="text-tertiary capitalize"> - <DateLabel date={comment.time.date} /></small></h4>
                {comment.title && <p className="text-secondary"><strong>{comment.title}</strong></p>}
                <p className="text-secondary whitespace-pre-wrap">{comment.body}</p>
              </div>
            </div>
          )}
        </div>
      }
    </I18n>
  );
}
